import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=857fd648&"
import script from "./Login.vue?vue&type=script&lang=js&"
export * from "./Login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('857fd648')) {
      api.createRecord('857fd648', component.options)
    } else {
      api.reload('857fd648', component.options)
    }
    module.hot.accept("./Login.vue?vue&type=template&id=857fd648&", function () {
      api.rerender('857fd648', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Auth/Login.vue"
export default component.exports